import { React, useEffect, useState } from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "../styles.css";
import { useAuthContext } from '../hooks/useAuthContext';
import { useContentsContext } from "../hooks/useContentsContext";
import { useContentGeneration } from "../hooks/useContentGeneration";
//  import Pagination from "../Components/History-pagination";
// import ContentsDetails from "../Components/ContentsDetails";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import dayjs from 'dayjs';
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import { MdOutlinePreview } from "react-icons/md";
import { Modal } from "flowbite-react";
import {  AiFillDelete } from "react-icons/ai";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import * as marked from 'marked';

import { Helmet } from "react-helmet";
import { useLogout } from "../hooks/useLogout";
function History() {


  const { user,dispatch } = useAuthContext()

  const [search, setSearch] = useState("")
  const {logout} = useLogout();
  const {  dispatchcontent } = useContentsContext()
  const { editGeneratedContent,allHistory } = useContentGeneration()
  //fetch saved history for respective flash only
  //Fetch saved history data
  const notify = (response) => toast(response);
  const navigate = useNavigate()
  const [openModal, setOpenModal] = useState(false);
  const[Name,setName] = useState();
  const[data,setData]=useState();
  const [flashId, setFlashId] = useState("")
  // const getHistory = async () => {
  //   // const content = await fetchHistory()

  //   dispatchcontent({ type: 'FETCH_CONTENTS', payload: content })
 
  //   setContent(content)

  // }'
  const users = Cookies.get('token')
  useEffect(() => {
    const users = Cookies.get('token')

    if(!users ){
      logout()
    }

try{


    const User = jwtDecode(users)
    const checkToken = async() =>{
      const isExpired = dayjs.unix(User.exp).diff(dayjs())< 1;
   
    if(!isExpired){
    // getHistory()
    }else{
   
      const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/user/refresh-token`, {
        method: 'GET',
        headers: {'Content-Type':'application/json',
    },
    credentials:'include'
    })
   
  if(response.status === 200){

     const json = await response.json()

     dispatch({ type: 'LOGIN', payload: json.token })
     navigate("/")
  }else{
    logout()
  }
    }
  
  }
    
  
  
  checkToken()
}catch(e){
  
  if(e.message.includes("Invalid token specified")){
    logout()
  }
}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
//     const handleClick = async (e) => {
// e.preventDefault()
//       const response = await fetch('https://api.contentflashai.com/api/history/' + flashId, {
//         method: "DELETE",
//         headers: {
//           'Authorization': `Bearer ${user}`
//         }
  
//       })
//       const json = await response.json()
  
//       if (!response.ok) {
    
//       }
//       if (response.ok) {
  
//         dispatchcontent({ type: 'DELETE_CONTENTS', payload: json })
  
//       }
//     }
    const handleClick = async (deleteHis) => {

      const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/history/` + deleteHis, {
        method: "DELETE",
        headers: {
          'Authorization': `Bearer ${users}`
        }
  
      })
      const json = await response.json()
  
      if (!response.ok) {
    
      }
      if (response.ok) {
  
        dispatchcontent({ type: 'DELETE_CONTENTS', payload: json })
  
      }
    }
    const handleEdit = async(e) =>{
      e.preventDefault()
      const edit = {documentName:Name,content:data}
      const response = await editGeneratedContent(flashId,edit)
      
      if(response.ok){
        notify("Edit successful")
      }else{
        notify("Something went wrong, try again in sometime")
      }
      
      }
          function onCloseModal() {
            setOpenModal(false);
          }
          const renderResponse = (cont) => {
          
            const html = marked.parse(cont.replace(/\n/g, '<br />'));
            setData(html)
      
          };
  if (user) {
    return (

      <div className=" min-h-screen lg:w-3/4 sm:w-3/4 w-2/3 mx-auto ">
        <Helmet>
                <meta charSet="utf-8" />
                <title>History - Content Flash AI</title>
               <meta name="description" content="Content Flash AI is an AI based content generator. Generate blogs, emails,etc in seconds."/>
            </Helmet>
        <div className="flex">

          <h1 className="dark:text-white font-Rajdhani bg-gradient-to-r from-black from 1% via-red-500  to-orange-600 to-100% inline-block text-transparent bg-clip-text">History</h1>

        </div>



       

        <div>
<div className="flex shadow-sm my-4 border-1 border-slate-300 font-normal">
          <input
            type="search"
            name="search"
            id="search"
            placeholder="search....start typing..."
            className="dark:bg-[#2e3247] dark:text-[#99a0ac] w-full px-3 text-gray-900 outline-none py-1 focus:outline-none"
            onChange={(e) => setSearch(e.target.value)}
          />

        </div> 
        
        <div>
        <table className="table-auto w-full mb-10  dark:text-white font-Rajdhani border shadow-sm">
  <thead className="border-b ">
    <tr className="">
      <th className="p-3">Content</th>
      <th className="">Flash</th>
      <th>Created At</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody >
     {allHistory && allHistory.filter((history) => {
                return search.toLowerCase() === '' ? history : history.content.toLowerCase().includes(search)
            }).map((history) => (    
    <tr className="border-b">
    
      <td className="text-md font-medium p-3">{history.documentName}</td>
      <td className="" ><span className="dark:bg-[#2e3247] dark:text-white  dark:ring-1 dark:ring-[#99a0ac]  bg-orange-100 text-orange-800 text-sm font-  px-2.5 py-0.5 rounded light:bg-gray-700 light:text-orange-400 light:border light:border-red-400 ">{history ?history.contentType :  null}</span></td>
      <td className="font-medium">{history && history.createdAt ?    <span className="text-md content-right px-2 py-0.5">{formatDistanceToNow(new Date(history.createdAt), { addSuffix: true })}</span> :  null  }</td>
   <td className="flex gap-3 pt-3">
   {/* eslint-disable-next-line no-sequences */}
   <span className="flex dark:hover:text-[slate-300] cursor-pointer" data-modal-target="crud-modal" data-modal-toggle="crud-modal" typeof="button" onClick={() => (setOpenModal(true), renderResponse(history.content), setName(history.documentName), setFlashId(history.uuid))}><MdOutlinePreview size={20} className="cursor-pointer" /></span>
      {/* eslint-disable-next-line no-sequences */}
      <span className="flex dark:hover:text-[slate-300] cursor-pointer" onClick={(e)=>(e.preventDefault(), handleClick(history.uuid))} >   <AiFillDelete size={20} className="cursor-pointer" /></span>
</td>
    </tr>
      ))} 
  </tbody>
  </table>


      {/* {contents && contents.filter((history) => {
                return search.toLowerCase() === '' ? history : history.content.toLowerCase().includes(search)
            }).map((history) => (

               <ContentsDetails Key={history.uuid} content={history} />
                 
            

            ))}  */}
            </div>
   {/* Modal for edit document */}
        


      
              {/* <button >Toggle modal</button> */}
           
              <Modal show={openModal}  size="7xl" onClose={onCloseModal} popup>
        <Modal.Header className="dark:bg-[#2e3247] ">

        </Modal.Header>
        <Modal.Body className="dark:bg-[#2e3247] dark:text-white">
        <h1 className="font-Rajdhani text-2xl  content-center">Edit - {Name}</h1>
        <form onSubmit={handleEdit}>
          <label className="text-xl font-medium font-Rajdhani">Name</label><br/>
        <input 
      className="dark:bg-[#2c2f44] dark:text-[#99a0ac] border font-medium rounded shadow-sm w-full font-Rajdhani  text-gray-900 outline-none px-3 py-1 focus:outline-none" 
        value={Name}
        onChange={(e) => setName(e.target.value)}
        />
        <ReactQuill className="font-Rajdhani mt-3  dark:text-[#99a0ac]" theme="snow" value={data} onChange={setData}/>
        <button type="submit" className="btn dark:bg-[#818998] dark:text-white dark:bg-none dark:rounded-2xl  dark:hover:bg-[#818998] dark:hover:text-white text-white  bg-gradient-to-r from-orange-700 to-orange-600   mt-2 cursor-pointer">Submit</button>
        </form>
        </Modal.Body>
      </Modal>
              {/* Modal for edit document */}
              
        </div>

      
        <ToastContainer
                    position="top-right"
                    autoClose={2000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
      </div>

    );

  }else{
    return navigate("/")
  }
}

export default History;